import axios from 'axios';

import { API_VERSION } from '@/apis/constants';
import { Api } from '@/typings/api';
import { ApiMethod, ApiService, buildUrl } from '@/utils/api';
import { getToken, TokenKey } from '@/utils/token';

import {
  GetUserAuthLogoutParams,
  GetUserAuthLogoutRes,
  // [PLOP ANCHOR] dtoImport
} from './logout.dto';

export const getUserAuthLogoutUrl = () =>
  buildUrl({
    service: ApiService.USER,
    version: API_VERSION[ApiService.USER],
    path: `/auth/logout`,
  });
// [PLOP ANCHOR] apisUrl

export const getUserAuthLogout: Api<GetUserAuthLogoutParams, GetUserAuthLogoutRes> = (payload) =>
  axios({
    url: getUserAuthLogoutUrl(),
    method: ApiMethod.GET,
    params: payload.query,
    headers: {
      Authorization: `Bearer ${getToken(TokenKey.TOKEN)}`,
    },
  });

// [PLOP ANCHOR] apisDefinition
